import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getGameBid, gameBidWinnerCheck } from 'slice/gamebidSlice';

import AdminTable from 'common/AdminTable';

const ListGameBid = () => {
    const dispatch = useDispatch()
    const [showModalWinner, setShowModalWinner] = useState(false);
    const [winningData, setWinningData] = useState({});
    const cartData = useSelector((state) => state.gameBid);
    const gameData = useSelector((state) => state.product);
    useEffect(() => {
        dispatch(getGameBid())
    }, [dispatch])

    const winnerCheck = () => {
        dispatch(gameBidWinnerCheck(winningData))
    }

    // Table Headers
    const tableHeaders = [

        {
            Header: 'User Id',
            accessor: 'customer.mobile',
        },

        {
            Header: 'Name',
            accessor: 'customer.name',
            Cell: ({ row }) => {
                return <>{row?.original?.customer?.name ? row.original.customer.name.toUpperCase() : ''}</>
            }
        },

        {
            Header: 'Game Id',
            accessor: 'product.name',
            Cell: ({ row }) => {
                const capitalize = (str) =>
                    str.replace(/\b\w/g, char => char.toUpperCase());

                return <>{row?.original?.product?.name ? capitalize(row.original.product.name) : ''}</>;
            }
        },
        {
            Header: 'Digit Type',
            accessor: 'digit_type',
            Cell: ({ row }) => (
                <>
                    {/* {row.original.digit_type === 1 ? `Single ${row.original.digit_label}` : row.original.digit_type === 2 ? `Jodi ${row.original.digit_label}` : `Patti ${row.original.digit_label}`} */}
                    {row.original.digit_label}


                </>
            )
        },
        {
            Header: 'Selected Number',
            accessor: 'selected_number',
        },
        {
            Header: 'Amount',
            accessor: 'amount',
        },
        {
            Header: 'Date',
            accessor: 'createdAt',
        }
    ];

    return (
        <>
            <div className='container-fluid mt-5'>
                <div className='mainheadig mx-4 d-flex'>
                    <h4 className='text-white font-weight-bold '>Game Bid </h4>
                    <button className="ml-auto btn btn-success mr-4" onClick={() => setShowModalWinner(!showModalWinner)}> Winner Check</button>
                </div>
                {cartData?.data?.length > 0 && (
                    <AdminTable tableHeaders={tableHeaders} tableData={cartData.data} />
                )}

                {showModalWinner && (
                    <div className="modal fade show" style={{ display: 'block' }} tabIndex="-1" role="dialog" aria-labelledby="editModalLabel" aria-hidden="true">
                        <div className="modal-dialog modal-dialog-centered modal-xl" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <button type="button" className="close" onClick={() => setShowModalWinner(false)} aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body text-center">
                                    <div className='col-sm-12 my-2'>
                                        <label htmlFor="gameID" className='float-left'>Select Game</label>
                                        <select onChange={(e) => setWinningData({ ...winningData, gameID: e.target.value })} className="form-control" id="gameID">
                                            <option value={''}></option>
                                            {gameData && gameData.data && gameData.data.map((item, index) => {
                                                return <option key={index} value={item.id}>{item.name}</option>
                                            })}
                                        </select>
                                    </div>
                                    <div className='col-sm-12 my-3'>
                                        <label htmlFor='typeID' className='float-left'>Select Type</label>
                                        <select onChange={(e) => setWinningData({ ...winningData, digit_label: e.target.value })} className="form-control" id="typeID">
                                            <option value={''}></option>
                                            <option value="Open">Open</option>
                                            <option value="Close">Close</option>
                                            <option value="Jodhi">Jodhi</option>
                                            <option value="Open Patti">Open Patti</option>
                                            <option value="Close Patti">Close Patti</option>

                                        </select>
                                    </div>
                                    <div className='col-sm-12 my-3'>
                                        <label htmlFor='typeID' className='float-left'>Winning Number</label>
                                        <input type='number' maxLength={3} className='form-control' onChange={(e) => setWinningData({ ...winningData, winNumber: e.target.value })} />
                                    </div>

                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-success" onClick={() => winnerCheck()}>Check</button>
                                    <button type="button" className="btn btn-secondary" onClick={() => setShowModalWinner(false)}>Close</button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}


            </div>
        </>
    )
}

export default ListGameBid;
